import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@guildeducationinc/recess';
import { useCurrentClient } from '@src/hooks/useCurrentClient';
import { useLocale } from 'pe-core-frontend';
import styles from './ClientWelcomeWrapper.module.scss';
export const ClientWelcomeWrapper = ({ children }) => {
    const { currentClient, loading } = useCurrentClient();
    const { t } = useLocale();
    if (loading || !currentClient) {
        return null;
    }
    if (currentClient.isActive) {
        return children;
    }
    else {
        return (_jsxs("div", { className: styles.clientWelcomeWrapper, children: [_jsx(Typography, { variant: 'h1', gutterBottom: 'md', children: t("You've arrived a bit early!") }), _jsx(Typography, { variant: 'body2', gutterBottom: 'md', children: t("{clientName}'s education benefit isn't available just yet, but it'll be here soon.", {
                        values: { clientName: currentClient?.name },
                    }) }), _jsx(Typography, { variant: 'body2', gutterBottom: 'md', children: t('Please check back later to log in or sign up.') })] }));
    }
};
